module.exports = __webpack_public_path__ + "static/openlaw3-26bf53e038c1defd0290aebd8815ccc4.svg";